import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import { setFlightTripSearchInputs } from '../../../../../store/slices/tripSearch';

import { autocompleteRequest } from '../../../../../store/slices/autocomplete';
import { AutocompleteType } from '../../../../../constants';
import flightSearchInput from '../../../../../helpers/selectors/flightSearchInput';
import { updateFlightSearchObj } from '../../../../../store/slices/flight';
import SingleSelectAutocompleteFilter from '../../../../Filters/SingleSelectAutocompleteFilter';

const CarrierCodeFilter = ({
  tripId, variant, filterSpacingClass, currentIndex,
}) => {
  const dispatch = useDispatch();
  const { track } = useAnalytics();
  const isTripSearch = !tripId;
  const { searchInputs } = useSelector(flightSearchInput(tripId, isTripSearch));
  const airlinesAutocompleteResults = useSelector((store) => store
    .autocomplete.airlinesAutocompleteResults);

  const handleChange = useCallback((value) => {
    const payload = {
      tripId,
      searchObj: {
        flightSegments: searchInputs.flightSegments ? [...searchInputs.flightSegments] : [],
        page: 1,
      },
    };

    payload.searchObj.flightSegments[currentIndex] = {
      ...payload.searchObj.flightSegments[currentIndex],
      carrierCode: value,
    };

    if (isTripSearch) dispatch(setFlightTripSearchInputs({ ...payload.searchObj }));
    else dispatch(updateFlightSearchObj(payload));
    track('flightSegmentCarrierCode.handleChange', {
      filterAirlines: JSON.stringify(value),
      currentIndex,
      tripId,
    });
  }, [currentIndex, dispatch, isTripSearch,
    searchInputs.flightSegments, track, tripId]);

  const handleInputChange = useCallback((query) => {
    if (query && query.length < 2) return;
    dispatch(autocompleteRequest({
      autocompleteTypes: AutocompleteType.AIRLINES,
      responseType: 'airlinesAutocompleteResults',
      query,
    }));
  }, [dispatch]);

  return (
    <SingleSelectAutocompleteFilter
      onChange={(value) => handleChange(value)}
      label="Airline"
      tooltipPrependText="Marketing Airline"
      placeholderText="Start typing marketing carrier..."
      options={airlinesAutocompleteResults}
      value={(searchInputs && searchInputs.flightSegments
            && searchInputs.flightSegments[currentIndex]
            && searchInputs.flightSegments[currentIndex].carrierCode)}
      variant={variant}
      onInputChange={handleInputChange}
      filterButtonMaxWidth="max-w-full w-full"
      filterSpacingClass={filterSpacingClass}
      bgClassName={isTripSearch ? 'bg-searchInput-0' : ''}
    />
  );
};

CarrierCodeFilter.propTypes = {
  tripId: PropTypes.string,
  filterSpacingClass: PropTypes.string,
  variant: PropTypes.string,
  currentIndex: PropTypes.number,
};

CarrierCodeFilter.defaultProps = {
  tripId: undefined,
  filterSpacingClass: undefined,
  variant: undefined,
  currentIndex: undefined,
};

export default memo(CarrierCodeFilter);
